import React, { useCallback } from 'react';
import dragUpload from '@/pages/aigc/assets/svg/drag_upload.svg';

import './index.scss';
import { getLocale, useIntl } from 'umi';
import { createPortal } from 'react-dom';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';

interface IDragDropUpload {
  isVisible: boolean;
  popupContainer: HTMLElement | null;
}

const DragDropUpload: React.FC<IDragDropUpload> = (props: IDragDropUpload) => {
  const { isVisible, popupContainer } = props;
  const { formatMessage } = useIntl();

  const renderPreviewOverlay = useCallback(() => createPortal(
    <div className="dba-drag-drop-container">
      {/* 上传区域内容 */}
      <div className="dba-upload-area">
        <img className="dba-upload-area-icon" src={dragUpload} alt="上传图标" />
        <div className="dba-upload-area-text">
          <p className="dba-upload-area-text-title">
            {formatMessage({ id: 'dba_upload_drag_title' })}
          </p>
          <p className="dba-upload-area-text-content">
            {/* {formatMessage({ id: 'dba_upload_img_tips_darg' })} */}
            <FormatHtmlTextToReact text={formatMessage({ id: 'dba_upload_img_tips_darg' })} />
          </p>
        </div>
      </div>
    </div>,
    popupContainer || document.getElementById('root') as Element
  ), [popupContainer, getLocale()]);

  return isVisible ? renderPreviewOverlay() as any : null;
};

export default DragDropUpload;